<footer class="site-footer" role="contentinfo">
	<div class="page-width site-footer__inner-wrap">
		<small class="copyright">&copy; 2017-{{currentYear}} - The National Board for Respiratory Care</small>
		<nav class="nav footer-nav" *ngIf="!isAssessment">
			<ul class="nav__list footer-nav__list">
				<li class="nav__item footer-nav__item">
					<a class="nav__link footer-nav__link" href="{{privacyLink}}">Privacy Policy</a>
				</li>
				<li class="nav__item footer-nav__item">
					<a class="nav__link footer-nav__link" href="{{termsLink}}">Terms &amp; Conditions</a>
				</li>
				<li class="nav__item footer-nav__item">
					<a class="nav__link footer-nav__link" href="{{contactLink}}">Contact</a>
				</li>
			</ul>
		</nav>
	</div>
</footer>